<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import SupplierForm from "./components/SupplierForm.vue"

defineProps<{
  supplier: {
    id?: number | null
    company_id: number | ""
    name: string
    document: string
    email: string
  }
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <SupplierForm
      mode="create"
      title="Criar Fornecedor"
      subtitle="Cadastre fornecedores para receber cotacoes e controlar custo por produto."
      :supplier="supplier"
      :companies="companies"
      :errors="errors"
    />
  </AppShell>
</template>

